import { Component, OnInit, Inject } from '@angular/core';
import { APIPostFactoryService } from "src/app/services/post-factory.service";
import createApp from '@shopify/app-bridge';
import { APIKey } from 'src/environments/environment';
import { Router } from '@angular/router';
import { AuthService } from '../../../auth/auth.service';
import { Loading } from '@shopify/app-bridge/actions';
import { BillingPostFactoryService } from '../../../services/post-factory.service';
import { APIGetFactoryService } from '../../../services/get-factory.service';
import { LOCAL_STORAGE, StorageService } from 'ngx-webstorage-service';


@Component({
  selector: 'app-larf-remix-register',
  templateUrl: './larf-remix-register.component.html',
  styleUrls: ['./larf-remix-register.component.scss']
})
export class LarfRemixRegisterComponent implements OnInit {

  constructor(@Inject(LOCAL_STORAGE) private storage: StorageService, private apiPostFactory: APIPostFactoryService, public router: Router, private authService: AuthService, public BillingPostFactory: BillingPostFactoryService, private APIGetFactory: APIGetFactoryService) { }

  queryParams: any;

  ngOnInit() {
    this.queryParams = this.getParams(window.location.search);
    this.apiPostFactory.customPost("LB4_Merchant", "shopifyRemixRegister", this.queryParams).subscribe((response: any) => {
      if (response.signature_verified) {
        sessionStorage.setItem('lb4b-host', this.queryParams.host);
        let tokenObject = {};
        tokenObject["merchant"] = response.merchant;
        tokenObject["appname"] = response.appname;
        tokenObject["platform"] = response.platform;
        tokenObject["domain"] = response.domain;
        localStorage.setItem("decodedTokenObj", JSON.stringify(tokenObject));
        this.authService.isLoggedInSuccess = true;
        this.getKcToken(response);
      } else {
        this.authService.isLoggedInSuccess = false;
      }
    });
  }
  getParams = function (searchUrl) {
    var str = searchUrl;
    var objURL = {};
    console.log('str replace', str);
    if (str) {
      str.replace(
        new RegExp("([^?=&]+)(=([^&]*))?", "g"),
        function ($0, $1, $2, $3) {
          objURL[$1] = $3;
        }
      );
    }
    console.log('objURL ', objURL);
    return objURL;
  }

  async getKcToken(response) {
    this.APIGetFactory.customGet('LARF_Keycloak', 'getKcTokenMerchant', { merchantId: '67f603b28a3fbd0011554436' }).subscribe(data => {
      this.storage.set('lb4b-token', JSON.stringify(data));
      localStorage.removeItem("jwToken");
      setInterval(() => {
        var toBackend = {
          access_token: JSON.parse(this.storage.get('lb4b-token')).access_token,
          refresh_token: JSON.parse(this.storage.get('lb4b-token')).refresh_token
        }
        this.APIGetFactory.customGet('LARF_Keycloak', 'refreshKcToken', toBackend).subscribe(data => {
          this.storage.set('lb4b-token', JSON.stringify(data));
        })
        // 1sec=1*1000 so 1min=60*1000 similarly 30mins=30*60=1800==>1800*1000 secs
      }, 1800 * 1000);

      const app = createApp({
        apiKey: APIKey['larfsh'],
        host: this.queryParams.host,
      });
      var loading = Loading.create(app);
      loading.dispatch(Loading.Action.STOP);
      this.router.navigate(['livevue-three-point-zero/set-up']);
    })
  }
}
